module.exports = __webpack_public_path__ + "img/dots.b61f85ee.svg";